const he = () => {
  const H = window.themeCore.utils.Toggle,
    u = window.themeCore.utils.cssClasses,
    I = window.themeCore.utils.formToJSON,
    B = window.themeCore.utils.on,
    J = window.themeCore.utils.QuantityWidget,
    Q = window.themeCore.utils.CartUpsell,
    x = window.themeCore.utils.Preloder,
    k = Shopify.currency.rate || 1,
    P = window.themeCore.objects.shop.money_format,
    r = {
      section: '[data-section-type="cart-template"]',
      sectionDrawer: '[data-section-modification="drawer"]',
      upsellDrawer: "#CartUpsellDrawer",
      subtotal: ".js-cart-subtotal",
      container: ".js-cart-container",
      content: ".js-cart-content",
      buttonsContent: ".js-cart-footer-button",
      cartButton: ".js-cart-button",
      additionalButtons: ".js-cart-footer-additional-buttons",
      cartItem: "[data-cart-item]",
      quantity: ".js-quantity",
      termsAndConditionsCheckbox: ".js-terms-and-conditions-checkbox",
      quantityError: ".js-cart-item-error-message",
      remove: ".js-cart-item-remove",
      closeButton: ".js-cart-close-button",
      cartNoteField: ".js-cart-notes-field",
      cartDrawerNoteControlText: ".js-cart-note-control-text",
      cartFooterButtonMessage: ".js-cart-footer-button-message",
      submit: '[type="submit"]',
      scrollable: "[data-scrollable]",
      upsellMobileTrigger: ".js-cart-upsell-trigger",
      freeShippingBar: ".js-cart-shipping",
      progressBar: ".js-cart-shipping-progress-bar",
      shippingTextEl: ".js-cart-shipping-amount-msg",
      shippingIcon: ".js-cart-shipping-icon",
      progressBarHiddenText: ".js-shipping-bar-progress-hidden-text",
      shippingLabel: ".js-cart-shipping-label",
      cartTotal: "[data-cart-total]",
      discount: ".js-cart-discount-block",
      discountAccordionContainer: ".js-cart-discount-accordion-container",
      accordionItem: ".js-accordion-item",
      accordionControl: ".js-accordion-control",
      discountForm: ".js-cart-discount-form",
      discountApply: ".js-cart-discount-apply-button",
      discountPill: ".js-cart-discount-pill",
      discountRemove: ".js-cart-discount-pill-remove",
      discountError: ".js-cart-discount-error",
      discountErrorCode: ".js-cart-discount-error-code",
      discountErrorShipping: ".js-cart-discount-error-shipping",
    },
    w = { ...u, empty: "is-empty" };
  let S = [],
    j = [];
  function V() {
    (W(), $(), G(), F());
  }
  let M = !1;
  function W() {
    j = [...document.querySelectorAll(r.sectionDrawer)].map((e) => {
      const o = H({ toggleSelector: e.id, closeAccordionsOnHide: !1 });
      o.init();
      const t = {
        el: e,
        toggle: { open: () => o.open(e), close: () => o.close(e) },
      };
      return (K(t), t);
    });
  }
  function K(e) {
    !e ||
      !e.toggle ||
      (window.themeCore.EventBus.listen(
        `cart:drawer:${e.el.id}:open`,
        e.toggle.open,
      ),
      window.themeCore.EventBus.listen(
        `cart:drawer:${e.el.id}:close`,
        e.toggle.close,
      ));
  }
  function $() {
    ((S = Array.from(document.querySelectorAll(r.section)).map((e) => ({
      el: e,
      id: e.dataset.sectionId,
      content: e.querySelector(r.content),
    }))),
      S.forEach((e) => {
        const o = Array.from(e.el.querySelectorAll(r.quantity));
        !o || !o.length
          ? (e.quantityWidgets = [])
          : (e.quantityWidgets = o.map((a) =>
              J(a, { onQuantityChange: re }).init(),
            ));
        const t = x(e.el);
        (t && (e.preloader = t.init()), (e.upsell = {}));
        const n = e.el.querySelector(r.upsellDrawer),
          c = Q(n, { onFormSubmit: le });
        if (c && n) {
          e.upsell = c.init();
          const a = e.el.querySelector(r.upsellMobileTrigger);
          if ((a && a.replaceWith(a.cloneNode(!0)), a)) {
            let d = e.el.querySelector(r.upsellMobileTrigger);
            if (d) {
              let s = d.querySelector("[data-js-toggle='CartUpsellDrawer']");
              s && s.setAttribute("aria-expanded", "false");
            }
          }
          ((e.upsell.drawer = H({
            toggleSelector: e.upsell.container.id,
            closeAccordionsOnHide: !1,
            overlay: !1,
          })),
            e.upsell.drawer.init());
          const l = x(e.upsell.container);
          (l && (e.upsell.preloader = l.init()),
            window.themeCore.EventBus.listen(
              `Toggle:${e.el.id}:close`,
              function () {
                e.upsell.drawer.close(e.upsell.container);
              },
            ));
        }
        (B("click", e.el, ne), B("submit", e.el, ie), B("click", e.el, ce));
      }),
      pe(),
      me(),
      window.themeCore.LazyLoadImages.init(),
      window.themeCore.Accordion.init(),
      window.themeCore.objects.settings.show_shipping_rates_calculator &&
        window.Shopify &&
        ge());
  }
  function G() {
    (window.themeCore.EventBus.listen("cart:updated", de),
      window.themeCore.EventBus.listen("cart:refresh", D),
      window.themeCore.EventBus.listen("cart:drawer:open", O),
      window.themeCore.EventBus.listen("cart:drawer:refresh-and-open", X),
      window.themeCore.EventBus.listen("cart:drawer:close", ee),
      document.addEventListener(
        "click",
        (e) =>
          e.target.closest(r.closeButton) &&
          window.themeCore.EventBus.emit("cart:drawer:close"),
      ),
      document.addEventListener("change", Y));
  }
  async function Y(e) {
    const o = e.target.closest(r.cartNoteField),
      t = document.querySelector(r.cartDrawerNoteControlText);
    if (o) {
      T();
      try {
        await window.themeCore.CartApi.makeRequest(
          window.themeCore.CartApi.actions.UPDATE_CART,
          { note: o.value },
        );
      } catch (n) {
        console.log(n);
      } finally {
        (A(),
          t &&
            (o.value !== ""
              ? (t.textContent = window.themeCore.translations.get(
                  "cart.general.edit_note",
                ))
              : (t.textContent =
                  window.themeCore.translations.get("cart.general.note"))));
      }
    }
  }
  function L() {
    return S.map((e) => e.id);
  }
  async function Z() {
    const e = L(),
      o = new URL(window.location.href);
    return (
      o.searchParams.set("sections", e.join(",")),
      o.searchParams.set("lazyload", "false"),
      fetch(o.href).then((t) => t.json())
    );
  }
  function O(e) {
    if (e && e.id) {
      window.themeCore.EventBus.emit(`cart:drawer:${e.id}:open`);
      return;
    }
    const o = j.find((t) => t.toggle && t.toggle.open);
    o && o.toggle.open();
  }
  function X(e) {
    D().then(() => {
      O(e);
    });
  }
  function ee(e) {
    if (e && e.id) {
      window.themeCore.EventBus.emit(`cart:drawer:${e.id}:close`);
      return;
    }
    j.forEach((o) => {
      o.toggle && o.toggle.close && o.toggle.close();
    });
  }
  function T() {
    S.forEach((e) => {
      (e.preloader && e.preloader.show(),
        e.upsell && e.upsell.preloader && e.upsell.preloader.show());
    });
  }
  function A() {
    S.forEach((e) => {
      (e.preloader && e.preloader.hide(),
        e.upsell && e.upsell.preloader && e.upsell.preloader.hide());
    });
  }
  async function D(e = null) {
    const o =
      e &&
      Object.keys(e).length === 0 &&
      Object.getPrototypeOf(e) === Object.prototype
        ? e
        : await Z();
    if (!o) return !1;
    (S.map((t) => {
      const n = new DOMParser().parseFromString(o[t.id], "text/html"),
        c = n.querySelector(r.section),
        a = n.querySelector(r.content),
        l = n.querySelector(r.subtotal),
        d = n.querySelector(r.buttonsContent),
        s = n.querySelector(r.additionalButtons),
        p = n.querySelector(r.cartFooterButtonMessage),
        m = n.querySelector(r.upsellDrawer),
        g = n.querySelector(r.discount);
      let y = !1;
      const f = t.el.querySelector(r.discountAccordionContainer);
      if (f) {
        const i = f.querySelector(r.accordionItem);
        i && (y = i.classList.contains(w.active));
      }
      if (!c || !a) return;
      t.el.classList.toggle(w.empty, c.classList.contains(w.empty));
      const h = t.el.querySelector(r.content);
      if (!h) return;
      if (d) {
        const i = t.el.querySelector(r.buttonsContent);
        i && i.innerHTML !== d.innerHTML && (i.innerHTML = d.innerHTML);
      }
      if (p) {
        const i = t.el.querySelector(r.cartFooterButtonMessage);
        i && i.outerHTML !== p.outerHTML && (i.outerHTML = p.outerHTML);
      }
      if (s) {
        const i = t.el.querySelector(r.additionalButtons);
        i &&
          i.innerHTML !== s.innerHTML &&
          i.classList.toggle(w.hidden, s.classList.contains(w.hidden));
      }
      if (l) {
        const i = t.el.querySelector(r.subtotal);
        i && (i.innerHTML = l.innerHTML);
      }
      if (g) {
        const i = t.el.querySelector(r.discount);
        if ((i && (i.innerHTML = g.innerHTML), y)) {
          const b = i.querySelector(r.discountAccordionContainer);
          if (b) {
            const E = b.querySelector(r.accordionItem);
            (E.classList.add(u.active),
              E.querySelector(r.accordionControl).setAttribute(
                "aria-expanded",
                !0,
              ));
          }
        }
      }
      const C = t.el.querySelector(r.upsellMobileTrigger);
      if ((C && C.classList.toggle(w.hidden, !m), !m && t.upsell.container))
        ((t.upsell.container.outerHTML = ""), t.upsell.container.remove());
      else if (m)
        if (t.upsell.container) {
          const i = t.upsell.container.querySelector(r.scrollable),
            b = i ? i.scrollTop : 0,
            E = t.upsell.refresh(m);
          if (E) {
            t.upsell.container.innerHTML = E;
            const _ = t.upsell.container.querySelector(r.scrollable);
            _ && _.scrollTo({ top: b });
          } else
            ((t.upsell.container.outerHTML = ""), t.upsell.container.remove());
        } else t.el.insertAdjacentHTML("beforeend", m.outerHTML);
      h.innerHTML = a.innerHTML;
    }),
      $(),
      F());
  }
  function te(e, o) {
    window.themeCore.EventBus.emit("product-card:quick-view:clicked", {
      productHandle: e,
      variant: o,
    });
  }
  async function oe(e, o) {
    try {
      await window.themeCore.CartApi.makeRequest(
        window.themeCore.CartApi.actions.ADD_TO_CART,
        { id: e, quantity: o },
      );
    } catch (t) {
      return t && t.description;
    }
  }
  function re(e) {
    if (!e || !e.controls || !e.controls.input) return;
    T();
    const t = e.controls.input.dataset.itemKey,
      n = e.quantity.value,
      c = L().join(",");
    window.themeCore.CartApi.makeRequest(
      window.themeCore.CartApi.actions.CHANGE_CART_ITEM_QUANTITY,
      t,
      n,
      c,
    )
      .then(async (a) => {
        let l = a.items.find((d) => d.key === t);
        if (l && n !== l.quantity) {
          const d = window.themeCore.translations.get("cart.errors.quantity", {
            count: l.quantity,
            title: l.title,
          });
          throw (
            (M = !0),
            setTimeout(() => {
              M = !1;
            }, 0),
            { description: d }
          );
        }
      })
      .catch((a) => {
        ae(e, a);
      })
      .finally(() => {
        A();
      });
  }
  function ne(e) {
    const o = e.target.closest(r.remove);
    if (!o) return;
    (e.preventDefault(), T());
    const t = L().join(","),
      n = o.dataset.itemKey;
    window.themeCore.CartApi.makeRequest(
      window.themeCore.CartApi.actions.REMOVE_CART_ITEM,
      n,
      t,
    ).finally(() => {
      A();
    });
  }
  function N() {
    return [...document.querySelectorAll(r.discountPill)].map(
      (o) => o.dataset.discountCode,
    );
  }
  function se(e) {
    const o = [];
    return (
      (e.cart_level_discount_applications || []).forEach((t) => {
        const n = t.discount_application ?? t;
        n.type === "discount_code" && o.push(n.title);
      }),
      (e.items || []).forEach((t) => {
        (t.line_level_discount_allocations || []).forEach((n) => {
          const c = n.discount_application ?? n;
          c.type === "discount_code" && o.push(c.title);
        });
      }),
      [...new Set(o)]
    );
  }
  async function ie(e) {
    const o = e.target.closest(r.discountForm);
    if (o) {
      (e.preventDefault(), e.stopPropagation(), T());
      try {
        const n = I(o).discount,
          c = N();
        if (c.includes(n)) return;
        const a = L().join(",");
        (await window.themeCore.CartApi.makeRequest(
          window.themeCore.CartApi.actions.UPDATE_CART,
          { discount: [...c, n].join(",") },
          a,
        ),
          o.reset());
      } catch (t) {
        console.log("Error while submit discount:", t);
      } finally {
        A();
      }
    }
  }
  function R(e) {
    const o = document.querySelector(r.discountError),
      t = document.querySelector(r.discountErrorCode),
      n = document.querySelector(r.discountErrorShipping);
    (o.classList.remove(u.hidden),
      e === "discount_code"
        ? (t.classList.remove(u.hidden), n.classList.add(u.hidden))
        : e === "shipping_error" &&
          (t.classList.add(u.hidden), n.classList.remove(u.hidden)));
  }
  async function ce(e) {
    if (!e.target.closest(r.discountRemove)) return;
    const t = e.target.closest(r.discountPill);
    if (!t) return;
    const n = t.dataset.discountCode;
    if (n) {
      T();
      try {
        const c = N(),
          a = c.indexOf(n);
        if (a === -1) return;
        c.splice(a, 1);
        const l = L().join(",");
        await window.themeCore.CartApi.makeRequest(
          window.themeCore.CartApi.actions.UPDATE_CART,
          { discount: c.join(",") },
          l,
        );
      } catch (c) {
        console.log("Error while removing discount:", c);
      } finally {
        A();
      }
    }
  }
  function ae(e, o) {
    if (!e || !o) return;
    e.rollbackValue();
    const t = e.widget.closest(r.cartItem);
    if (!t) return;
    const n = t.querySelector(r.quantityError);
    n.innerHTML = o.message || o.description;
  }
  function le(e) {
    const o = e.target;
    if (!o) return;
    e.preventDefault();
    const t = I(o),
      { id: n, handle: c, singleVariant: a, quantity: l } = t;
    if (!JSON.parse(a)) {
      te(c, n);
      return;
    }
    T();
    const d = o.querySelector(r.submit);
    (d && d.classList.add(w.loading),
      oe(n, Number(l)).then(() => {
        (d && d.classList.remove(w.loading),
          window.themeCore.EventBus.emit("Toggle:CartUpsellDrawer:close"),
          A());
      }));
  }
  function F() {
    const e = document.querySelector(r.termsAndConditionsCheckbox),
      o = document.querySelector(r.cartButton),
      t = document.querySelector(r.cartFooterButtonMessage);
    !e ||
      (t && t.classList.contains(u.disabled)) ||
      ((o.disabled = !e.checked),
      e.addEventListener("change", () => {
        o.disabled = !e.checked;
      }));
  }
  function de(e) {
    let o = null;
    (e && (o = e.sections),
      M ||
        D(o).then(() => {
          ue(e);
          const t = window.themeCore.objects.settings.show_cart_notification,
            n = !e.params.some((c) => c.noOpen);
          !JSON.parse(t) &&
            n &&
            window.themeCore.EventBus.emit("cart:drawer:open");
        }));
  }
  function ue(e) {
    const o = e.params.find(
      (s) => s && typeof s == "object" && "discount" in s,
    );
    if (!o) return;
    const t = o.discount.split(",").at(-1),
      n = e.discount_codes;
    if (n.find((s) => s.code === t && !s.applicable)) {
      R("discount_code");
      return;
    }
    const a = se(e);
    !n
      .filter((s) => s.applicable)
      .map((s) => s.code)
      .every((s) => a.includes(s)) && R("shipping_error");
  }
  function pe() {
    let e = document.querySelector(r.freeShippingBar);
    if (!e) return;
    let o = Number(e.getAttribute("data-cart-total")),
      t = e.getAttribute("data-amount-cents") * k,
      n = (o / t) * 100,
      c = e.getAttribute("data-amount-message"),
      a = e.getAttribute("data-success-message"),
      l = e.querySelector(r.progressBar),
      d = e.querySelector(r.shippingTextEl),
      s = e.querySelector(r.shippingIcon),
      p = e.querySelector(r.progressBarHiddenText),
      m = window.themeCore.translations
        .get("cart.shipping_bar.progress")
        .replace("{{ value }}", n.toFixed(1));
    const g = e.querySelector(r.shippingLabel);
    if (
      (e.style.setProperty("--shipping-bar-progress-value", n + "%"),
      p && (p.textContent = m),
      n < 100)
    ) {
      let y = t - o,
        f = window.themeCore.utils.formatMoney(y, P),
        h = c.replace("{amount}", `<strong>${f}</strong>`);
      ((d.innerHTML = h),
        l.classList.remove(u.hidden),
        s && s.classList.add(u.hidden),
        g && g.classList.remove("cart-shipping__label--success"));
    } else
      ((d.innerHTML = a),
        l.classList.add(u.hidden),
        s && s.classList.remove(u.hidden),
        g && g.classList.add("cart-shipping__label--success"));
  }
  function me() {
    const e = document.querySelector(r.cartFooterButtonMessage);
    if (!e) return;
    const o = document.querySelector(r.additionalButtons),
      t = document.querySelector(r.cartButton),
      n = Number(e.getAttribute("data-cart-total")),
      c = e.getAttribute("data-amount-message"),
      a = e.getAttribute("data-success-message"),
      l = e.getAttribute("data-amount-cents") * k;
    if ((n / l) * 100 < 100) {
      const s = l - n,
        p = window.themeCore.utils.formatMoney(s, P);
      (o && o.classList.remove(u.hidden),
        e.classList.add(u.disabled),
        (e.innerHTML = c.replace("{rest}", `<strong>${p}</strong>`)),
        t.setAttribute("disabled", ""));
    } else
      (o && o.classList.add(u.hidden),
        e.classList.remove(u.disabled),
        (e.innerHTML = a),
        t.removeAttribute("disabled"));
  }
  function ge() {
    const e = document.querySelector(".js-get-ship-rates");
    if (!e) return;
    new window.Shopify.CountryProvinceSelector(
      "cart-address-country",
      "cart-address-province",
      { hideElement: "cart-address-province-container" },
    );
    const o = document.querySelectorAll(".js-ship-rate-field"),
      t = document.getElementById("cart-address-country"),
      n = document.getElementById("cart-address-province"),
      c = document.getElementById("cart-address-zip"),
      a = document.getElementById("cart-rates-wrapper");
    let l = { country: "", province: "", zip: "" };
    (o.forEach(function (s) {
      let p = "keyup";
      (s.tagName === "SELECT" && (p = "change"),
        s.addEventListener(p, () => {
          d(s);
        }));
    }),
      e &&
        e.addEventListener("click", function (s) {
          (s.preventDefault(),
            e.setAttribute("disabled", ""),
            (l.country = t.value || ""),
            (l.province = n.value || ""),
            (l.zip = c.value || ""));
          const p = `shipping_address[country]=${l.country}&shipping_address[province]=${l.province}&shipping_address[zip]=${l.zip}`,
            m = encodeURI(`${p}`);
          try {
            fetch(`/cart/prepare_shipping_rates.json?${m}`, { method: "POST" })
              .then((g) => g.text())
              .then((g) => {
                const y = JSON.parse(g);
                if (typeof y == "object" && y !== null) {
                  (Object.entries(y).forEach(([f, h]) => {
                    const C = document.getElementById(`cart-address-${f}`),
                      i = document.getElementById(`error-cart-address-${f}`);
                    i &&
                      ((i.textContent = `${h}`),
                      i.classList.remove(u.hidden),
                      C.setAttribute("aria_invalid", "true"),
                      C.setAttribute(
                        "aria_describedby",
                        `error-cart-address-${f}`,
                      ));
                  }),
                    e.removeAttribute("disabled"));
                  return;
                }
                fetch(`/cart/async_shipping_rates.json?${m}`)
                  .then((f) => f.text())
                  .then((f) => {
                    const h = JSON.parse(f),
                      C = h ? h.shipping_rates : [];
                    if ((e.removeAttribute("disabled"), C.length > 0)) {
                      a.innerHTML = "";
                      const i = document.createElement("ul");
                      (i.classList.add("cart-shipping-calc__rate-list"),
                        C.forEach((b) => {
                          const E = document.createElement("li");
                          i.appendChild(E);
                          const _ = b.name;
                          let v = b.price;
                          const U = b.delivery_days;
                          let q = "";
                          (v === "0.00"
                            ? (v = window.themeCore.translations.get(
                                "cart.shipping_rates.price_free",
                              ))
                            : (v = `${window.themeCore.utils.formatMoney(v.includes(".") ? v : v + ".00", window.themeCore.objects.shop.money_format)}`),
                            U.length &&
                              (U.forEach((z, fe) => {
                                q = fe === 0 ? z : `${q}-${z}`;
                              }),
                              (q = `<span>${q} days</span>`)),
                            (E.innerHTML = `<span class="cart-shipping-calc__rate-name">${_}:</span> ${q} ${v}`));
                        }),
                        a.appendChild(i));
                    } else
                      a.innerHTML = window.themeCore.translations.get(
                        "cart.shipping_rates.no_shipping",
                      );
                  });
              });
          } catch (g) {
            console.log(g, "Error with shipping rates");
          }
        }));
    function d(s) {
      if (!s) return;
      const p = s.id.split("cart-address-")[1],
        m = document.getElementById(`error-cart-address-${p}`);
      (s.removeAttribute("aria_invalid"),
        s.removeAttribute("aria_describedby"),
        m && (m.classList.add(u.hidden), (m.textContent = "")));
    }
  }
  return Object.freeze({ init: V });
};
export { he as C };
